import { Injectable } from '@angular/core';
import { TokenAuthService } from '../../shared/token-auth.service';
import { BehaviorSubject, first } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationStateService {
  // public endpoint:string = environment.apiUrl + '/image-upload';
  private userCurrentState = new BehaviorSubject<boolean>(this.tokenAuth.isSignedin());
  userAuthState = this.userCurrentState.asObservable();

  private userInfoState = new BehaviorSubject<boolean>(this.tokenAuth.isSignedin());
  userInfo = this.userInfoState.asObservable();


  constructor(
    public tokenAuth: TokenAuthService,
    private _router: Router,
    private _http: HttpClient,
  ) { }

  setAuthState(user: any) {
    this.userCurrentState.next(true);
    this.userInfoState.next(user);
  }

  checkAuthState() {
    return this._http.post(`${environment.apiAuthUrl}/validate-token`, {

    }).pipe(first()).subscribe((response)=> {

      if(response['data'].loggedIn === false){
        return this._router.navigate(['/login'])
      }
    });

  }

}